'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestCharges', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenserequestcharges', {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenserequestcharges/' + id, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_request_charge) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licenserequestcharges/';

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_request_charge: license_request_charge
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/licenserequestcharges/' + id, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
;